import { StreamLanguage } from "@codemirror/language";
import { c, cpp, objectiveC, objectiveCpp } from "@codemirror/legacy-modes/mode/clike";
import { Extension } from "@codemirror/state";

// Map a file name to a CodeMirror language extension for the C family.
// Uses the already-installed legacy `clike` modes (no extra dependency).
//
// .h is ambiguous (C / C++ / Objective-C). We use the Objective-C++ mode for it
// because it's the most permissive — it still highlights plain C/C++ headers,
// and this codebase leans Objective-C, so `@interface`/`@property` in headers
// get coloured too.
export function languageExtensionsForFile(fileName?: string | null): Extension[] {
  if (!fileName) return [];
  const lower = fileName.toLowerCase();
  const dot = lower.lastIndexOf(".");
  const ext = dot >= 0 ? lower.slice(dot) : "";

  switch (ext) {
    case ".c":
      return [StreamLanguage.define(c)];
    case ".cc":
    case ".cpp":
    case ".cxx":
    case ".c++":
    case ".hpp":
    case ".hh":
    case ".hxx":
    case ".h++":
      return [StreamLanguage.define(cpp)];
    case ".m":
      return [StreamLanguage.define(objectiveC)];
    case ".mm":
      return [StreamLanguage.define(objectiveCpp)];
    case ".h":
      return [StreamLanguage.define(objectiveCpp)];
    default:
      return [];
  }
}
